import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import siteConfig from "../siteConfig";
import ContactForm from "./ContactForm";
import cityPageContent from "../data/city-page-content";

const CityContactCard = ({ city, service }) => {
  // Only pages whose design calls for it get the paired estimate form.
  const showForm = Boolean(cityPageContent.forPage(city, service).heroTitle);
  // Cities we have no office in fall back to the Battle Creek headquarters,
  // so the card always shows a real address and the number that office answers.
  const office = siteConfig.officeForCity(city) || siteConfig.offices[0];
  const phone = office.phone || siteConfig.phone;
  const phoneHref = `tel:${siteConfig.phoneE164(phone)}`;

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={
            showForm ? "grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start" : ""
          }
        >
          <div className="bg-neutral-50 rounded-2xl border border-neutral-200 shadow-sm max-w-lg mx-auto w-full p-8 md:p-10">
          <h2 className="text-2xl md:text-3xl font-display font-extrabold text-neutral-900 text-center mb-8 leading-tight">
            Get In Touch With Us
          </h2>
          <ul className="list-none p-0 m-0 space-y-5">
            {siteConfig.email ? (
              <li className="flex items-center gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white border border-neutral-200 flex items-center justify-center">
                  <Mail size={18} className="text-brand-500" />
                </div>
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="text-neutral-800 hover:text-brand-500 no-underline font-medium break-all"
                >
                  {siteConfig.email}
                </a>
              </li>
            ) : null}
            <li className="flex items-center gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white border border-neutral-200 flex items-center justify-center">
                <Phone size={18} className="text-brand-500" />
              </div>
              <a
                href={phoneHref}
                className="text-neutral-800 hover:text-brand-500 no-underline font-medium"
              >
                {phone}
              </a>
            </li>
            <li className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white border border-neutral-200 flex items-center justify-center">
                <MapPin size={18} className="text-brand-500" />
              </div>
              <div className="text-neutral-800 font-medium leading-relaxed pt-1.5">
                <div>{office.address}</div>
                <div>
                  {office.city}, {office.state} {office.zip}
                </div>
              </div>
            </li>
          </ul>
          </div>

          {/* The design pairs the contact details with an estimate form here
              (Figma 442:1546), the same card as the hero. */}
          {showForm ? (
            <div className="bg-white border-t-4 border-brand-600 rounded-xl p-8 pb-6 shadow-xl">
              <div className="inline-block pointer-events-none text-[0.8125rem] font-semibold bg-[#FFEB3B] mb-2 py-1 px-2 rounded">
                Online Special
              </div>
              <h3 className="font-display font-extrabold text-xl text-neutral-900 leading-snug mb-2">
                Request a Free Roofing Estimate With Our Experts!
              </h3>
              <p className="text-neutral-600 mb-4">
                Request Free Pricing Today for Your Remodeling Needs!
              </p>
              <ContactForm hideLabels={true} showPlaceholders={true} footerContained={true} />
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default CityContactCard;
